import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeCctvComponent } from './home-cctv/home-cctv.component';
import { CctvcampusComponent } from './cctvcampus/cctvcampus.component';
import { BuildingsComponent } from './buildings/buildings.component';
import { CampusComponent } from './campus/campus.component';

import { VideoComponent } from './video/video.component';
import { CityComponent } from './city/city.component';
import { StateComponent } from './state/state.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SigninComponent } from './signin/signin.component';
import { UserComponent } from './module/user/user.component';
import { TotaldvrComponent } from './totaldvr/totaldvr.component';
import { authGuard } from './auth/auth.guard';
// import { CounsellingComponent } from './modules/counselling/counselling/counselling.component';
import { DashboardCctvComponent } from './dashboard-cctv/dashboard-cctv.component';
import { DashboardCctvNotconnectedComponent } from './dashboard-cctv-notconnected/dashboard-cctv-notconnected.component';

import { DvrNvrstatusComponent } from './dvr-nvrstatus/dvr-nvrstatus.component';
import { DashboardCctvStreamingComponent } from './dashboard-cctv-streaming/dashboard-cctv-streaming.component';
import { DashboardCctvNovideoComponent } from './dashboard-cctv-novideo/dashboard-cctv-novideo.component';
import { DvrConnectedComponent } from './dvr-connected/dvr-connected.component';
import { DvrNotconnectedComponent } from './dvr-notconnected/dvr-notconnected.component';
import { DashboardCctvNotstreamingComponent } from './dashboard-cctv-notstreaming/dashboard-cctv-notstreaming.component';
import { BulkUploadDvrDetailsComponent } from './bulk-upload-dvr-details/bulk-upload-dvr-details.component';
import { AddDvrComponent } from './add-dvr/add-dvr.component';
import { TableResizeComponent } from './table-resize/table-resize.component';
import { CollectSchoolDetailsComponent } from './modules/collect-school-details/collect-school-details.component';
import { HrModule } from './hr/hr.module';
import { FEATURE_LAZY_ROUTES } from './core/routing/feature-lazy.routes';
import { MainUserComponent } from './module/main-user/main-user.component';





const routes: Routes = [

  { path: 'signin', component: SigninComponent },
  { path: 'signin/:token', component: SigninComponent },
  // { path: 'counselling', component: CounsellingComponent},

  {
    path: '',
    component: UserComponent,
    children: [
      { path: '', redirectTo: '/signin', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
      { path: 'channel', component: VideoComponent },
      { path: 'city/:id', component: CityComponent, canActivate: [authGuard] },
      { path: 'state/:id', component: StateComponent, canActivate: [authGuard] },
      { path: 'home', component: HomeCctvComponent, canActivate: [authGuard] },
      { path: 'campus/:id', component: CampusComponent, canActivate: [authGuard] },
      { path: 'cctvcampus/:id', component: CctvcampusComponent },
      { path: 'dashboardcctv', component: DashboardCctvComponent, canActivate: [authGuard] },
      {
        path: 'dashboardcctvnotconnected',
        component: DashboardCctvNotconnectedComponent,
        canActivate: [authGuard],
      },
      {
        path: 'dashboardcctvstreaming',
        component: DashboardCctvStreamingComponent,
        canActivate: [authGuard],
      },
      { path: 'dashboardnovideo', component: DashboardCctvNovideoComponent, canActivate: [authGuard] },
      {
        path: 'dashboardcctvnotstreaming',
        component: DashboardCctvNotstreamingComponent,
        canActivate: [authGuard],
      },
      { path: 'totaldvr', component: TotaldvrComponent, canActivate: [authGuard] },
      { path: 'dvr-nvrstatus', component: DvrNvrstatusComponent, canActivate: [authGuard] },
      { path: 'dvr-connected', component: DvrConnectedComponent, canActivate: [authGuard] },
      { path: 'dvr-notconnected', component: DvrNotconnectedComponent, canActivate: [authGuard] },
      { path: 'dvr/upload', component: BulkUploadDvrDetailsComponent, canActivate: [authGuard] },
      { path: 'dvr/add-dvr', component: AddDvrComponent, canActivate: [authGuard] },
      // {path:'totaldvr',component:TableResizeComponent ,canActivate:[authGuard] },
      
      // Feature modules (lazy) — same URLs as before via matchers / prefixes
      ...FEATURE_LAZY_ROUTES,
    ]
  },

  // start new structure //

  //   {
  //   path: '',
  //   component: MainUserComponent,
  //   children: [
  //     { path: '', redirectTo: '/signin', pathMatch: 'full' },
  //     { path: 'dashboard', component: DashboardComponent, canActivate: [authGuard] },
  //     { path: 'channel', component: VideoComponent },
  //     { path: 'city/:id', component: CityComponent, canActivate: [authGuard] },
  //     { path: 'state/:id', component: StateComponent, canActivate: [authGuard] },
  //     { path: 'home', component: HomeCctvComponent, canActivate: [authGuard] },
  //     { path: 'campus/:id', component: CampusComponent, canActivate: [authGuard] },
  //     { path: 'cctvcampus/:id', component: CctvcampusComponent },
  //     { path: 'dashboardcctv', component: DashboardCctvComponent, canActivate: [authGuard] },
  //     {
  //       path: 'dashboardcctvnotconnected',
  //       component: DashboardCctvNotconnectedComponent,
  //       canActivate: [authGuard],
  //     },
  //     {
  //       path: 'dashboardcctvstreaming',
  //       component: DashboardCctvStreamingComponent,
  //       canActivate: [authGuard],
  //     },
  //     { path: 'dashboardnovideo', component: DashboardCctvNovideoComponent, canActivate: [authGuard] },
  //     {
  //       path: 'dashboardcctvnotstreaming',
  //       component: DashboardCctvNotstreamingComponent,
  //       canActivate: [authGuard],
  //     },
  //     { path: 'totaldvr', component: TotaldvrComponent, canActivate: [authGuard] },
  //     { path: 'dvr-nvrstatus', component: DvrNvrstatusComponent, canActivate: [authGuard] },
  //     { path: 'dvr-connected', component: DvrConnectedComponent, canActivate: [authGuard] },
  //     { path: 'dvr-notconnected', component: DvrNotconnectedComponent, canActivate: [authGuard] },
  //     { path: 'dvr/upload', component: BulkUploadDvrDetailsComponent, canActivate: [authGuard] },
  //     { path: 'dvr/add-dvr', component: AddDvrComponent, canActivate: [authGuard] },

  //     // Feature modules (lazy) — same URLs as before via matchers / prefixes
  //     ...FEATURE_LAZY_ROUTES,
  //   ],
  // },


  // End new structure //

  { path: 'facultyTracking', loadChildren: () => import('./modules/faculty-tracking/faculty-tracking.module').then(m => m.FacultyTrackingModule) },
  { path: 'employeeGrievance', loadChildren: () => import('./modules/employee-grevience/employee-grevience.module').then(m => m.EmployeeGrevienceModule) },
  // { path: 'faculty', loadChildren: () => import('./modules/faculty-tracking-dashbaord/faculty-tracking-dashbaord.module').then(m => m.FacultyTrackingDashbaordModule) },

  { path: 'collect-school-details/:uniref/:studentName', component: CollectSchoolDetailsComponent },
  { path: 'score', loadChildren: () => import('./modules/score/score.module').then(m => m.ScoreModule) },
  {
    path: 'employeeProfile',
    loadChildren: () => import('./hr/employee/employee.module').then(m => m.EmployeeModule),
  },

  // { path: '**', redirectTo: '/signin' }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
